module.exports = __webpack_public_path__ + "static/mental_health_secret_banner_m@2x-fa010aec0ee2fcbab5ddaa1e5946afc6.png";